import { carrierStatuses, statusesEnum } from '../../carriers/constants';
import { vendorEnums } from '../constants';

export const vendorStatusesEnum = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' },
  { id: 'PENDING', name: 'Pending' },
];

export const vendorCsv = {
  type: 'carrier',
  statusList: carrierStatuses,
  requiredStatus: true,
  statusEnum: 'statuses',
  statusesEnum: statusesEnum,
};


export const vendorTypes = [
  {id: vendorEnums.CARRIER, name: 'Carrier'},
  {id: vendorEnums.CO_BROKER, name: 'Co-Broker'},
  {id: vendorEnums.WAREHOUSE, name: 'Warehouse'},
  {id: vendorEnums.CUSTOM_BROKER, name: 'Custom Broker'},
  {id: vendorEnums.FREIGHT_FORWARDER, name: 'Freight Forwarder'},
  {id: vendorEnums.INTERMODAL_FREIGHT_FORWARDER, name: 'Int. Freight Forwarder'},
  {id: vendorEnums.FACTORED, name: 'Factored Vendor'},
  {id: vendorEnums.VENDOR, name: 'Vendor'},
  // {id: vendorEnums.INHOUSE_PROFILE, name: 'Inhouse Profile'},
];

export const vendorModesEnums = [
  {id: 'DRY', name: 'Dry'},
  {id: 'REEFER', name: 'Reefer'},
  {id: 'RAIL_REEFER', name: 'Rail Reefer'},
  {id: 'POWER', name: 'Power Only'},
  {id: 'FLATBED', name: 'Flatbed or Step Deck'},
  {id: 'DRAYAGE', name: 'Drayage'},
  {id: 'REEFER_DRAYAGE', name: 'Reefer Drayage'},
  {id: 'BOX_TRUCK', name: 'Box Truck'},
  {id: 'AIR', name: 'Air'},
  {id: 'SEA', name: 'Sea'},
  {id: 'RAIL', name: 'Rail'},
  {id: 'OTHER', name: 'Other'},
  {id: 'MAIN', name: 'Main'},
  {id: 'CUSTOMS', name: 'Customs'},
  {id: 'WAREHOUSE', name: 'Warehouse'},
  {id: 'COLD_STORAGE', name: 'Cold Storage'},
  {id: 'AUTO_CARRIER', name: 'Auto Carrier'},
  {id: 'SPRINTER_VAN', name: 'Sprinter Van'},
  {id: 'HOTSHOT', name: 'Hotshot'},
]